
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('rect',{attrs:{"width":"16","height":"2","y":"7","fill":"#fff","rx":"1"}}),_c('rect',{attrs:{"width":"16","height":"2","y":"2","fill":"#fff","rx":"1"}}),_c('rect',{attrs:{"width":"10","height":"2","x":"6","y":"12","fill":"#fff","rx":"1"}})])
      }
    
      }
    